import DateSelection from '@/app/massive_download/models/DateSelection'

class RequiredSelection {
  constructor ({ description, granularity, dateSelection }) {
    this.description = description
    this.granularity = granularity
    this.dateSelection = new DateSelection(dateSelection)
  }
}

export default RequiredSelection



// WEBPACK FOOTER //
// ./src/app/massive_download/models/RequiredSelection.js